const Collapser = () => {
    document.getElementById('main-nav').classList.remove('expanded')
    document.getElementById('moduleOverlay').classList.remove('enabled')
}

export default Collapser